var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7639 7.468L1.24861 0.0360474C1.22374 0.0164728 1.19386 0.00430796 1.1624 0.000949957C1.13093 -0.00240805 1.09916 0.00317696 1.07072 0.0170637C1.04229 0.0309504 1.01835 0.0525757 1.00165 0.0794558C0.984949 0.106336 0.97617 0.137381 0.97632 0.169025V1.80064C0.97632 1.90406 1.02487 2.00327 1.10508 2.06659L8.70378 7.99991L1.10508 13.9332C1.02276 13.9966 0.97632 14.0958 0.97632 14.1992V15.8308C0.97632 15.9722 1.13885 16.0503 1.24861 15.9638L10.7639 8.53182C10.8447 8.46874 10.9102 8.38804 10.9552 8.29587C11.0002 8.2037 11.0236 8.10248 11.0236 7.99991C11.0236 7.89734 11.0002 7.79613 10.9552 7.70396C10.9102 7.61178 10.8447 7.53109 10.7639 7.468Z",
    fill: "#3C9AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.188c855ee553811b482ac6858d4a3a33.svg";
export { ForwardRef as ReactComponent };